/*
 * Add-ons are added AFTER the main product, in their own JSON request.
 *
 * They must not ride in the main product form: Customily rewrites that form's
 * submission and only handles a single item (extra items[] -> text/plain -> 400).
 * So on the product page we only REMEMBER the selection at the moment the shopper
 * clicks Add to cart; the cart page (where the theme lands after a successful add)
 * then checks the main item really went in and adds the remembered add-ons.
 * If the main add failed (e.g. personalization incomplete) the main line never
 * grows, nothing is added, and the memory is dropped — no orphan add-ons.
 *
 * Runs on both the product page and the cart page; each part is a no-op elsewhere.
 * Known limit: only the "page" cart type is wired (theme setting cart_type). A drawer
 * cart would need the same reconcile call on the theme's cart-update event.
 */
(function () {
  var KEY = 'gd_pending_addons';
  var MAX_AGE_MS = 10 * 60 * 1000;

  function lineQty(cart, variantId) {
    return cart.items.reduce(function (n, it) { return it.variant_id === variantId ? n + it.quantity : n; }, 0);
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- product page: remember selection at click time ---------- */
  var root = document.querySelector('[data-gd-addons]');
  if (root) {
    var cartSnapshot = null; // fetched ahead of the click: the click itself may navigate away
    getCart().then(function (c) {
      cartSnapshot = c;
      // Protection covers the whole order: once it is in the cart, stop offering it.
      [].forEach.call(root.querySelectorAll('[data-gd-addon][data-once="true"]'), function (i) {
        if (lineQty(c, Number(i.dataset.variantId)) > 0) { i.checked = false; i.closest('.gd-addon').hidden = true; }
      });
    }).catch(function () {});

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-gd-addon]');
      if (input) input.closest('.gd-addon').classList.toggle('is-selected', input.checked);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[type="submit"], button[name="add"]');
      if (!btn || !btn.form || root.contains(btn)) return;
      if ((btn.form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      var idInput = btn.form.querySelector('[name="id"]');
      if (!idInput) return;
      var mainId = Number(idInput.value);
      var items = [].map.call(root.querySelectorAll('[data-gd-addon]:checked'), function (i) {
        return { id: Number(i.dataset.variantId), quantity: 1, once: i.dataset.once === 'true' };
      });
      if (!items.length) { sessionStorage.removeItem(KEY); return; }
      sessionStorage.setItem(KEY, JSON.stringify({
        mainId: mainId,
        beforeQty: cartSnapshot ? lineQty(cartSnapshot, mainId) : 0,
        items: items,
        ts: Date.now()
      }));
    }, true);
  }

  /* ---------- cart page: protection is one-per-order and never alone ---------- */
  // The product-page flow already adds it once, but the cart's quantity box, the
  // protection product's own page, or removing the main item can all break that.
  // Variant ids come from the cart template (window.gdProtectionVariantIds).
  function enforceProtectionRules() {
    var ids = window.gdProtectionVariantIds || [];
    if (!ids.length) return Promise.resolve(false);
    return getCart().then(function (cart) {
      var prot = cart.items.filter(function (it) { return ids.indexOf(it.variant_id) !== -1; });
      if (!prot.length) return false;
      var updates = {};
      var onlyProtection = prot.length === cart.items.length;
      prot.forEach(function (it, idx) {
        var want = onlyProtection ? 0 : (idx === 0 ? 1 : 0); // keep exactly one line, qty 1
        if (it.quantity !== want) updates[it.key] = want;
      });
      if (!Object.keys(updates).length) return false;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { if (r.ok) location.reload(); return true; });
    }).catch(function () { return false; });
  }

  if (/^\/cart\/?$/.test(location.pathname)) {
    // The theme edits the cart via ajax without reloading, so re-check shortly after
    // any interaction (remove button, quantity change) instead of hooking its requests.
    var recheck;
    ['click', 'change'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        clearTimeout(recheck); recheck = setTimeout(enforceProtectionRules, 1800);
      }, true);
    });
  }

  /* ---------- cart page: add remembered add-ons once the main item is in ---------- */
  if (/^\/cart\/?$/.test(location.pathname)) {
    var raw = sessionStorage.getItem(KEY);
    if (!raw) { enforceProtectionRules(); return; }
    sessionStorage.removeItem(KEY); // one shot, whatever happens next
    var pending;
    try { pending = JSON.parse(raw); } catch (e) { return; }
    if (!pending || Date.now() - pending.ts > MAX_AGE_MS) return;

    getCart().then(function (cart) {
      if (lineQty(cart, pending.mainId) <= pending.beforeQty) return enforceProtectionRules(); // main add did not happen
      var toAdd = pending.items.filter(function (it) {
        return !(it.once && lineQty(cart, it.id) > 0); // protection: once per cart
      }).map(function (it) { return { id: it.id, quantity: it.quantity }; });
      if (!toAdd.length) return enforceProtectionRules();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: toAdd })
      }).then(function (r) { if (r.ok) location.reload(); });
    }).catch(function () {});
  }
})();
